import * as types from 'live/redux/actionTypes';
import { RSAA } from 'redux-api-middleware';

export const liveClearGames = () => ({
  type: types.LIVE_GAMES_CLEAR,
});

export const liveLoadGames = ({
  alias = '',
  isActive,
  atgProducts,
  onlyNoErrors = false,
  onlyOwnGames: owned = false,
  size,
  sort,
  sportProducts,
  started,
}) => {
  const type = isActive ? 'active' : 'completed';
  const params = { isActive, size };

  if (isActive) {
    params.started = started;
  }

  if (owned) {
    params.owned = owned;
  } else {
    params.alias = alias;
  }

  if (atgProducts) {
    params.atgProducts = atgProducts;
  }
  if (sportProducts) {
    params.sportProducts = sportProducts;
  }
  if (onlyNoErrors) {
    params.onlyNoErrors = onlyNoErrors;
  }

  if (sort) {
    params.sort = sort;
  } else {
    params.sort = isActive ? 'lockTime,desc' : 'closeTime,desc';
  }

  const query = new URLSearchParams(params);
  let queryParams = query.toString();

  queryParams = queryParams.includes('productOrder')
    ? queryParams
    : `${queryParams}&sort=productOrder,desc`;

  return {
    [RSAA]: {
      endpoint: `live/games?${queryParams}`,
      method: 'GET',
      types: [
        { type: types.LIVE_GAMES_REQUEST, meta: { type } },
        { type: types.LIVE_GAMES_RECEIVE, meta: { type } },
        { type: types.LIVE_GAMES_ERROR, meta: { type } },
      ],
    },
  };
};

export const liveDeleteGame = ({ id, type }) => ({
  [RSAA]: {
    endpoint: `live/delete/${id}`,
    method: 'DELETE',
    types: [
      { type: types.LIVE_GAME_DELETE_REQUEST, meta: { id, type } },
      { type: types.LIVE_GAME_DELETE_RECEIVE, meta: { id, type } },
      { type: types.LIVE_GAME_DELETE_ERROR, meta: { id, type } },
    ],
  },
});

export const liveSetSelectedGame = selectedGame => ({
  type: types.LIVE_GAME_SET,
  payload: selectedGame,
});
